import FreeShell from '@/shell/components/FreeShell';

export default function App() {
  return <FreeShell />;
}
